import {Analytics, GTag, GTagPageviewObserver} from '@plaudit/analytics';

Analytics.setup();

const gtag = GTag.getInstance();

if (gtag !== null) {
	gtag.addObserver(
		
		new GTagPageviewObserver(
			{
				pagePath: (value: string) => {
					return value === "/contact-success" // Contact Form
						//|| value === "/product-success"
						//|| value === "/find-a-contractor-success"
						//|| value === "/general-question-success" 
				}
			},
			() => {
				//if (facebookPixel !== null) facebookPixel.trackEventLead({ value: 500 });
			}
		)
	);
}